const UserRole = {
  SuperAdmin: 'SUPER_ADMIN',
  TechnicalSupport: 'TECHNICAL_SUPPORT',
  Forwarder: 'FORWARDER',
  Dispatcher: 'DISPATCHER'
}

export default UserRole
